export function isEqualOrBelowPACE4(version: string): boolean {
  if (!version) return false;

  // Normalize case (so "pace3" and "PACE3" are the same)
  const normalized = version.toUpperCase();

  // Extract number after PACE
  const match = normalized.match(/PACE(\d+)/);

  if (!match) {
    console.warn(`Invalid device version format: ${version}`);
    return false;
  }

  const versionNumber = parseInt(match[1], 10);

  return versionNumber <= 4;
}
